import axios from "axios";
import { toast } from "sonner";

// Action Types
export const SUBMIT_MCP_REQUEST = "SUBMIT_MCP_REQUEST";
export const SUBMIT_MCP_SUCCESS = "SUBMIT_MCP_SUCCESS";
export const SUBMIT_MCP_FAILURE = "SUBMIT_MCP_FAILURE";
export const SUBMIT_BATCH_MCP_REQUEST = "SUBMIT_BATCH_MCP_REQUEST";
export const SUBMIT_BATCH_MCP_SUCCESS = "SUBMIT_BATCH_MCP_SUCCESS";
export const SUBMIT_BATCH_MCP_FAILURE = "SUBMIT_BATCH_MCP_FAILURE";

// Action Creators
const submitMcpRequest = () => ({
    type: SUBMIT_MCP_REQUEST,
});

const submitMcpSuccess = (tool) => ({
    type: SUBMIT_MCP_SUCCESS,
    payload: tool,
});

const submitMcpFailure = (error) => ({
    type: SUBMIT_MCP_FAILURE,
    payload: error,
});

const submitBatchMcpRequest = () => ({
    type: SUBMIT_BATCH_MCP_REQUEST,
});

const submitBatchMcpSuccess = (tools) => ({
    type: SUBMIT_BATCH_MCP_SUCCESS,
    payload: tools,
});

const submitBatchMcpFailure = (error) => ({
    type: SUBMIT_BATCH_MCP_FAILURE,
    payload: error,
});

// Thunk Actions
export const submitMcp = (githubUrl) => async (dispatch) => {
    dispatch(submitMcpRequest());
    try {
        const response = await axios.post("/api/mcp/submit", { githubUrl });
        dispatch(submitMcpSuccess(response.data));
        toast.success("MCP submitted successfully");
        return response.data;
    } catch (error) {
        const errorMessage =
            error.response?.data?.error ||
            error.message ||
            "Failed to submit MCP";
        dispatch(submitMcpFailure(errorMessage));
        toast.error(errorMessage);
        throw error;
    }
};

export const submitBatchMcps = (mcps) => async (dispatch) => {
    dispatch(submitBatchMcpRequest());
    try {
        const response = await axios.post("/api/mcp/batch-submit", { mcps });
        dispatch(submitBatchMcpSuccess(response.data.tools));

        // Show success/error messages
        if (response.data.tools.length > 0) {
            toast.success(
                `Successfully submitted ${response.data.tools.length} MCP${
                    response.data.tools.length > 1 ? "s" : ""
                }`
            );
        }
        if (response.data.errors) {
            toast.error(
                `Failed to submit ${response.data.errors.length} MCP${
                    response.data.errors.length > 1 ? "s" : ""
                }`
            );
        }

        return response.data;
    } catch (error) {
        const errorMessage =
            error.response?.data?.error ||
            error.message ||
            "Failed to submit MCPs";
        dispatch(submitBatchMcpFailure(errorMessage));
        toast.error(errorMessage);
        throw error;
    }
};
